<template>
  <div :style="style" class="background_popup_gradient wrapper"></div>
</template>

<script lang="ts">
import Vue from 'vue';

type styleWrapper = { width: string; height: string; border?: string };

export default Vue.extend({
  name: 'PopupsBackground',
  props: {
    width: Number,
    height: Number
  },
  computed: {
    style(): styleWrapper {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      };
    }
  }
});
</script>

<style scoped>
.wrapper {
  border: 10px solid rgba(254, 254, 254, 0.4);
  border-radius: 30px;
}
</style>